import { FC } from 'react';
import { useSelector } from 'react-redux';
import { IState } from 'appRedux/createStore';
import clsx from 'clsx';
import { S3_PROFILE_BASE as S3_BASE } from 'common/common';

interface MenuAvatarProps {
  aliasInitial?: string;
  avatarId?: number;
  avatarBgId?: number;
}

const MenuAvatar: FC<MenuAvatarProps> = ({ aliasInitial, avatarId, avatarBgId }) => {
  const isFounder = useSelector<IState>((state) =>
    state.app.persistedState.userInfo?.groups?.includes('Founder')
  );

  return (
    <div className={isFounder ? 'sidemenu-avatar gold-border-wrap' : 'sidemenu-avatar'}>
      <div className="sidemenu-avater-blue">
        <div className="body-container">
          <div className="alias-outer alias-circle">
            {avatarId ? (
              <div
                className="sidemenu-avatar-icon alias-circle"
                style={{ backgroundImage: `url(${S3_BASE}/avatar-bg${avatarBgId}.png)` }}
              >
                <img
                  src={`${S3_BASE}/avatar${avatarId}.png`}
                  alt="avatar"
                  className="sidemenu-avatar-icon__img"
                />
              </div>
            ) : (
              <div className="alias-inner alias-circle">
                <span className="alias-initial heading2">{aliasInitial}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuAvatar;
